import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EstreamContractStatus } from 'brain-data/model/estream-contract-status.model';

@Injectable({ providedIn: 'root' })
export class EstreamContractStatusService {
  constructor(private http: HttpClient) {}

  getStatus(contractNumber: string): Observable<EstreamContractStatus> {
    const trimmed = contractNumber.trim();
    return this.http.get<EstreamContractStatus>(
      `${environment.apiBaseUrl}/brain/diff/contracts/${encodeURIComponent(trimmed)}/status`,
    );
  }
}
